export default __webpack_public_path__ + "static/media/information--end-of-two-way-traffic--g1.88eeaba6.png";